/*global define */
define([], function () {
    return Object;
});
